module.exports = __webpack_public_path__ + "static/media/focus-bg.846afe26.svg";